// BootLanding — neutral hold shown while something the first paint depends on resolves. Displayed
// for default landings and deep links until hosts + authz are ready.
//
// It holds the splash while it is up, so the wait is the splash's; the spinner and its label are what
// shows if the splash's cap passes first. `label` says why it is waiting when that is not the sign-in.

import { useLayoutEffect } from "react";
import { Spinner, holdSplash } from "@thekrystalship/krystal";

function BootLanding({ label }) {
  useLayoutEffect(() => holdSplash(), []);
  // Self-contained full-viewport hold — deliberately NOT the `.k-app` shell class,
  // whose grid-template-columns (sidebar + main) would pin this into the narrow
  // first column and push the content off-centre. Fixed overlay + flex centres on
  // both axes at every breakpoint.
  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 10,
      display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
      textAlign: "center", background: "var(--canvas)", color: "var(--fg-3)",
    }}>
      <Spinner size={26} />
      <div style={{ marginTop: 12, fontSize: 13, fontWeight: 600, color: "var(--fg-2)" }}>{label || "Signing you in\u2026"}</div>
    </div>
  );
}

export { BootLanding };
